import { createReducer, on } from '@ngrx/store';
import * as UsersActions from './user.actions';
import { UserDto } from '@shared/dto';
import { PaginatedListQuery } from '@shared/interfaces/paginated-list-query.interface';
import { logout } from '@auth/store/auth.actions';
import { State } from '@store/state.interface';

export const USERS_FEATURE_KEY = 'users';

export interface UsersState extends State<UserDto> {}

export const initialState: UsersState = {
  data: null,
  detail: null,
  total: 0,
  query: null,
  loading: false,
  error: null,
};

export const userReducer = createReducer(
  initialState,
  on(UsersActions.readUsers, (state, { query }) => ({
    ...state,
    query: query ?? state.query,
    loading: true,
    error: null,
  })),
  on(UsersActions.readUsersSuccess, (state, { data, total }) => ({ ...state, data, total, loading: false })),
  on(UsersActions.readUsersFailure, (state, { error }) => ({ ...state, loading: false, error })),
  // Detail (single entity): the resolver blocks activation and matches by id, so we
  // keep the previous detail during the load (no blank flash on the outgoing page).
  on(UsersActions.readUser, (state) => ({ ...state, loading: true, error: null })),
  on(UsersActions.readUserSuccess, (state, { user }) => ({ ...state, detail: user, loading: false })),
  on(UsersActions.readUserFailure, (state, { error }) => ({ ...state, loading: false, error })),
  // Keep the open detail in sync with mutations so the form/restore-banner stay
  // correct without a refetch (the list itself is refetched by reloadAfterMutation$).
  on(UsersActions.updateUserSuccess, (state, { user }) => ({
    ...state,
    detail: state.detail ? { ...state.detail, ...user } : state.detail,
  })),
  on(UsersActions.deleteUserSuccess, (state, { user }) => ({ ...state, detail: user })),
  on(UsersActions.restoreUserSuccess, (state, { user }) => ({ ...state, detail: user })),
  // Create/update/delete/restore change the page contents or totals, so the
  // current page is refetched (see UserEffects.reloadAfterMutation$) rather than
  // mutated in place — which would desync the paginator.
  on(logout, () => initialState),
);
